function TwoColumnDayBook() {
    return (
        <div>
            <h2>Two Column Day Book</h2>

            <p>
                Your complete information comes here.
            </p>
        </div>
    );
}

export default TwoColumnDayBook;